import {Component, Input, OnInit} from '@angular/core';
import {GenderEnum} from 'src/app/models/user/gender.enum';

@Component({
  selector: 'app-body-type',
  templateUrl: './body-type.component.html',
  styleUrls: ['./body-type.component.scss']
})
export class BodyTypeComponent implements OnInit {
  @Input() metadata: any;
  genderEnum = GenderEnum;

  constructor() { }

  ngOnInit(): void {
  }

}
